import { CanDeactivateFn } from '@angular/router';

export interface OrdenesPagarExitAware {
  isPaymentInProgress(): boolean;
}

/**
 * Bloquea la navegación si el cobro está en curso (state ∈ {invoicing, charging}).
 * El componente expone `isPaymentInProgress()` leyendo el state del
 * OrderPaymentFlowComponent via viewChild.
 *
 * Si el cajero confirma salir, el polling sigue del lado del backend y el
 * resultado se reflejará en el listado al volver. Si cancela, el flujo
 * continúa visible donde estaba.
 */
export const ordenesPagarExitGuard: CanDeactivateFn<OrdenesPagarExitAware> = (component) => {
  if (!component.isPaymentInProgress()) {
    return true;
  }

  return confirm(
    'El cobro está en curso. Si salís, no vas a ver el resultado acá — se reflejará en el listado cuando termine. ¿Salir igual?',
  );
};
